import { zipcode } from '@/schemas';
import { object, string } from 'yup';

export const schema = object({
  zipCode: zipcode,
  city: string().required(),
  streetName: string().required(),
  streetNumber: string().required(),
});
